import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/index';
import { Client } from '../client/client';
import { User } from '../auth/user.model';
import { ClientService } from '../client/client.service';
import { UIService } from '../shared/ui.service';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { StorageService } from '../storage/storage.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})

export class ProfileComponent implements OnInit, OnDestroy {

  isLoading = false;
  profileFormGroup: FormGroup;
  user: User;
  client: Client;

  addressReview = 'Aucun';
  mobileReview = 'Aucun';
  firstnameReview = 'Aucun';

  private loadingSubscription: Subscription;

  constructor(
    private router: Router,
    private _formBuilder: FormBuilder,
    private uiService: UIService,
    private authentication: AuthService,
    private clientService: ClientService
  ) { }

  ngOnInit() {

    this.profileFormGroup = this._formBuilder.group({
      address: ['', Validators.required],
      firstname: ['', Validators.required],
      email: [{value: '', disabled: true}, Validators.required],
      mobile: [{value: ''}, Validators.required]
    });

    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
    this.user = this.authentication.getUser();

    this.clientService.getProfile(this.user.token).subscribe((response: Client) => {
        this.client = response;
        this.uiService.loadingStateChanged.next(false);
        this.profileFormGroup.setValue({
          address: this.client.address_field,
          firstname: this.client.first_name,
          mobile: this.client.cell_field,
          email: this.client.email_field
        });
        this.uiService.loadingStateChanged.next(false);
    });
  }

  onSelectionChange(event) {
    console.log(event);
    if (event.selectedIndex === 1) {
      this.addressReview = this.profileFormGroup.value.address;
      this.firstnameReview = this.profileFormGroup.value.firstname;
      this.mobileReview = this.profileFormGroup.getRawValue().mobile;
    }
  }

  updateProfile() {
    this.client.address_field = this.profileFormGroup.value.address;
    this.client.first_name = this.profileFormGroup.value.firstname;
    this.client.cell_field = this.profileFormGroup.getRawValue().mobile;

    this.clientService.updateProfile(this.user.token, this.client).subscribe((response: User) => {
      this.authentication.updateUser(response);
      this.router.navigate(['/dashboard']);
    });
  }

  ngOnDestroy(): void {
    this.loadingSubscription.unsubscribe();
  }
}
